<template>
    <div>
        <v-dialog
            v-model="display"
            scrollable
            persistent
            :width="items.length ? '750' : '500'">
            <v-card>
                <v-card-title>
                    {{ $t('item_Search') }}
                </v-card-title>
                <v-card-text>
                    <v-text-field
                        v-model="search"
                        ref="searchField" 
                        @keypress.enter="searchItem"
                        :error="error.searchField.state"
                        :error-messages="error.searchField.message"
                        :loading="loading.items"
                        :label="$t('search')">
                    </v-text-field>
                     <v-data-table
                        v-if="items.length"
                        dense
                        hide-default-footer
                        :items="items"
                        disable-pagination
                        :height="items.length ? '300' : '100'"
                        v-model="selected.items"
                        :headers="headers.items"
                        show-select
                        single-select>
                    </v-data-table>
                </v-card-text>
                <v-card-actions>
                    <v-btn v-if="items.length" :disabled="!selected.items.length" @click="submit({target: 'submit'})" text>
                        {{ $t('btn_select') }}
                    </v-btn>
                    <v-btn @click="close" text>
                        {{ $t('BTN_CLOSE') }}
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn v-if="authorizations.items.create" @click="openItemDialog({editMode: false})" text>
                        <v-icon>mdi-database-plus</v-icon>
                        {{ $t("ITEM_NEW_TITLE") }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <ItemDialog
            @record="createAndSubmitItem"
            ref="itemDialog"/>
    </div>
</template>
<script>
import { mapActions, mapState } from 'vuex';
import ItemDialog from '@/components/ItemDialog';
export default {
    name: "SpareSearchDialog",
    components: {
        ItemDialog
    },
    data() {
        return {
            display: false,
            search: null,
            loading: {
                data: false,
                items: false,
            },
            selected: {
               items: [] 
            },
            headers: {
                items: [
                    {text: this.$t('ITEM_NAME'), value: "name"},
                    {text: this.$t('ITEM_PART_NUMBER'), value: "part_number"},
                    {text: this.$t('ITEM_DESCRIPTION'), value: "description"}
                ]
            },
            error: {
                searchField: {
                    state: false,
                    message: null
                }
            }, 
        }
    },
    computed: {
        ...mapState("item", ["items"]),
        ...mapState("authentication", ["authorizations"]),
    },
    methods: {
      ...mapActions("item", ["fetchItems", "restItems"]),
        open(params) {
            this.search = params;
            this.restItems();
            this.display = true;
            this.searchItem();
        },
         setError(message){
            this.error.searchField.state = true;
            this.error.searchField.message = message;
        },
        clearError(){
            this.error.searchField.state = false;
            this.error.searchField.message = null;
        },
        openItemDialog(params) {
            this.$refs.itemDialog.open(params);
        },
        createAndSubmitItem(params){
           this.submit({target: 'CreateAndSubmit', data: params})
        },
        async searchItem() {
           
            if(this.search) {
                this.restItems();
                this.clearError();
                this.loading.items = true;
                try {
                    await this.fetchItems({ search: this.search });
                    this.loading.items = false;
                    if(!this.items.length) this.setError(this.$t('no_result'));
                    if(this.items.length == 1) this.submit({ target: 'submit'});
                } catch(error) {
                    this.loading.items = false;
                    let message = error.response ? error.response.data.message : error; 
                    this.setError(message);
                }

            } else {
                this.setError(this.$t('rules_required'))
            }
       },

       submit(params) {
           if(params.target == 'CreateAndSubmit') {
                  this.$emit('submit', params.data);
           } else if(params.target == 'submit') {
               if(this.items.length == 1) this.$emit('submit', this.items[0]);
               else this.$emit('submit', this.selected.items[0]);
           }
            this.close();
       },
        close() {
            this.display = false;
            this.search = null;
            this.selected.items = [];
            this.restItems();
        }
    }
}
</script>